var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiagonalArrow = function SvgDiagonalArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    fillRule: "evenodd",
    d: "M10.5.438A.44.44 0 0 0 10.063 0h-5.25a.438.438 0 0 0 0 .875h4.193L.128 9.753a.438.438 0 0 0 .619.619l8.878-8.878v4.194a.438.438 0 0 0 .875 0z",
    clipRule: "evenodd"
  })));
};
export default SvgDiagonalArrow;